module.exports = __webpack_public_path__ + "media/images/wealthbar/2fa/laptop-19b9f2556d78e6d420afaf1a58905b66.svg";